import styled from 'styled-components/macro';

const TextAreaWrapper = styled.div`
  position: relative;
`;

export default TextAreaWrapper;
